import { Record } from "datocms-structured-text-utils";
import { StructuredTextPropTypes } from "react-datocms";

const renderInlineRecord: StructuredTextPropTypes<Record>["renderInlineRecord"] =
  (_inlineRecord) => null;

export default renderInlineRecord;
